import { State } from '@frontend-site/shared/utils';
import { ScreenSize } from './screen-size.enum';

export interface ScreenSizeState extends State {
    screenSize: ScreenSize;
}

export function createInitialState(): ScreenSizeState {
    return {
        screenSize: ScreenSize.Large
    };
}
